<template>
  <div class="alert">
    <el-dialog
      :visible.sync="visible"
      :width="width"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :show-close="showClose"
    >
      <div class="container">
        <div class="content">
          <img :src="iconImg" />
          <div class="contentText">
            <h4 class="subtitle" v-if="subTitle">{{ subTitle }}</h4>
            <span class="des" v-if="description" v-html="description"></span>
          </div>
        </div>
        <div class="btn_box">
          <el-button class="btn cancel" v-if="showCancelButton" @click="cancel"
            >取消</el-button
          >
          <el-button class="btn" type="primary" @click="confirm"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    };
  },
  props: {
    width: {
      default: "412px",
      type: String
    },
    title: {
      default: "福昕智慧打印",
      type: String
    },
    iconImg: {
      default: require("@/assets/img/share/error.png"),
      type: String
    },
    description: {
      default: "错误",
      type: String
    },
    subTitle: {
      default: "",
      type: String
    },
    showCancelButton: {
      default: false,
      type: Boolean
    },
    showClose: {
      default: true,
      type: Boolean
    },
    confirmText: {
      default: "确定",
      type: String
    }
  },
  methods: {
    handleClose(done) {
      done();
      this.$options.propsData.destoryInstance();
    },
    confirm() {
      this.visible = false;
      this.$options.propsData.callback && this.$options.propsData.callback();
      this.$options.propsData.destoryInstance();
    },
    cancel() {
      this.visible = false;
      this.$options.propsData.destoryInstance();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
.alert {
  ::v-deep {
    .el-dialog__body {
      padding: 17px 20px 20px;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 19px;
      letter-spacing: 0px;
      color: #333333;
    }
  }
}
.content {
  padding: 0 20px;
  display: flex;
  align-items: flex-start;
  width: 100%;
  .contentText {
    flex: auto;
    width: 0;
  }
  img {
    width: 28px;
    height: 28px;
    margin-right: 13px;
  }
  .subtitle {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 27px;
    letter-spacing: 0px;
    color: #333333;
  }
  .des {
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0px;
    color: #999999;
    line-height: 24px;
  }
}
.btn_box {
  display: flex;
  width: 100%;
  margin-top: 35px;
  flex-direction: flex-end;
  justify-content: flex-end;
}
.cancel {
  border-color: $theme-color;
  color: $theme-color;
}
.btn {
  width: 70px;
  height: 32px;
  line-height: 32px;
  padding: 0;
}
</style>
